var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasData)?_c('li',{staticClass:"splide__slide",staticStyle:{"width":"100vw"}},[_vm._t("default"),_c('div',{staticClass:"slide-spacer"})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }